import React from "react";

const useDialogCreateExpense = ({ methods, setDialogShowToggle, onSubmit }) => {
    const onCancel = () => {
        methods.reset();
        hideDialog();
        return;
    };

    const onConfirm = (e) => {
        e.preventDefault();
        e.stopPropagation();
        methods.handleSubmit(onSubmit)();
        return;
    };

    const openDialog = (e) => {
        e.preventDefault();
        e.stopPropagation();
        return setDialogShowToggle(true);
    };

    const hideDialog = () => {
        return setDialogShowToggle(false);
    };

    return {
        onCancel,
        onConfirm,
        openDialog,
        hideDialog,
    };
};

export default useDialogCreateExpense;
